<template>
  <div class="main-block">
    <div class="row" style="margin-bottom: 10px">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 add-button-wrapper">
        <b-button variant="primary" size="sm" @click="addItem">
          <BIconPlus /> <span> {{ 'New Entry' | i18n }}</span>
        </b-button>
      </div>
    </div>
    <div class="fields-block">
      <draggable group="values" :list="list" :force-fallback="true" :options="{ forceFallback: true }">
        <div v-for="(item, index) in list" :key="`field-${item.id}`" class="field-container" :style="index === list.length - 1 ? 'border:none' : ''">
          <div class="icons-block">
            <span style="font-size: 30px"><BIconJustify /></span>
          </div>
          <div class="inputs-block">
            <Input v-model="item.value" :form-group-id="`entry-${item.id}`" placeholder="Entry" :required="true" />
          </div>
          <div class="remove-block">
            <b-button
              v-show="list.length > 1"
              v-b-tooltip.hover
              :title="'delete' | i18n"
              class="close float-none mr-3"
              aria-label="Close"
              variant="light"
              @click="removeItem(item.id)"
            >
              <span aria-hidden="true">&times;</span>
            </b-button>
          </div>
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import Input from '../../../../common/input';
import { BIconJustify, BIconPlus } from 'bootstrap-vue';
import draggable from 'vuedraggable';

let timeoutID = null;

export default {
  name: 'DropdownValues',
  components: {
    Input,
    BIconJustify,
    BIconPlus,
    draggable,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data: function () {
    return {
      list: [],
      attachNote: false,
      noteName: '',
    };
  },
  watch: {
    list: {
      handler: function (newValue) {
        this.handleChange(newValue);
      },
      deep: true,
    },
  },
  created() {
    this.list = this.values.map((v) => ({ id: this.getID(), ...v }));
    if (!this.list.length) {
      this.list = [{ id: this.getID() }];
    }
  },
  methods: {
    getID() {
      return `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`;
    },
    timeoutForUpdate(fn) {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      setTimeout(() => {
        fn();
      }, 500);
    },
    handleChange(value) {
      this.timeoutForUpdate(() => this.onChange(value));
    },
    addItem() {
      this.list.push({ id: this.getID() });

      setTimeout(() => {
        const inputs = document.querySelectorAll('.fields-block input');
        const last = inputs[inputs.length - 1];
        if (last) {
          last.focus();
        }
      }, 500);
    },
    removeItem(id) {
      this.list = this.list.filter((i) => i.id !== id);
    },
  },
};
</script>

<style scoped lang="scss">
.drop-field-text {
  display: flex;
  text-align: center;
  justify-content: center;
  width: 100%;
  top: -36px;
  position: absolute;
}

.draggable-container {
  min-height: 100px;
}

.draggable-container span::before {
  content: ' ';
  background: rgba(230, 230, 230, 0.1);
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px dashed #e6e6e6;
  height: 50px;
}
.draggable-container span:empty::before {
  padding: 30px;
}
.draggable-container span:not(:empty)::before {
  opacity: 0;
  content: '';
}
.field-list-icon {
  width: 50px;
  height: 50px;
}
.field-container {
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 15px;
  margin: 10px 0;
  background: white;
}

::v-deep .text-input-group {
  margin-bottom: 0px;
  width: 100%;
  margin: 0 5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: 0 10px;
  cursor: pointer;
}

.icons-block {
  width: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.inputs-block {
  display: flex;
  flex: 1;
  margin-right: 20px;
}

.checkboxs-block {
  display: flex;
  flex: 1;
  padding-top: 2px;
}

.group-header {
  background: #fafafa;
  width: 100%;
  height: 60px;
  display: flex;
  align-content: center;
  align-items: center;
  color: #5f5f5f !important;
  font-size: 1.5rem !important;
  font-weight: 300;
}
.group-header span {
  padding: 0 15px;
  color: black;
}
.fields-block > div {
  min-height: 50px;
  position: relative;
}

.edit-btn {
  font-size: 14px;
  margin-left: 20px;
}

.remove-block {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.add-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.main-block {
  width: 100%;
  margin-top: -65px;
}
</style>
